import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { INTERIOR_DOORS_ELEMENT_BLOCK } from '../../../../interior-doors-constants';

type QualityAssuranceProps = {
  onConsultationSignupBtnClick: () => void;
};

export const QualityAssurance = ({ onConsultationSignupBtnClick }: QualityAssuranceProps) => (
  <>
    <ModalHeader title="Гарантия качества" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Мы&nbsp;даём 1&nbsp;год гарантии на&nbsp;услугу установки дверей, приобретённых
        в&nbsp;Лемана&nbsp;ПРО.
      </Typography>
      <Typography variant="m" size="body_long">
        А&nbsp;для владельцев Ключ-карты срок гарантии&nbsp;&mdash; 2&nbsp;года.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={INTERIOR_DOORS_ELEMENT_BLOCK}
        elementName="Записаться на консультацию"
        elementText="Гарантия качества"
        onClick={onConsultationSignupBtnClick}
        wide>
        Записаться на консультацию
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
